import { createClient } from 'contentful';

const space = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

const fallbackClient = {
  getEntries: async <T>() => ({
    items: [] as T[],
    limit: 0,
    skip: 0,
    sys: { type: 'Array' },
    total: 0,
  }),
} as unknown as ReturnType<typeof createClient>;

export const client =
  space && accessToken
    ? createClient({
        space,
        accessToken,
      })
    : fallbackClient;
